import { RouterProvider, createBrowserRouter } from "react-router-dom";
import SplashScreen from "src/components/SplashScreen/SplashScreen";
import NotFound from "src/components/NotFound/NotFound";
import { authRoutes, discountsRoutes, flightsRoutes, giftcardRoutes, hotelRoutes, topupRoutes, userRoutes } from "./routes";
import RouteWrapper from "./RouteGuard";
import AppInitializer from "./AppInitilizer";
import ScrollToTop from "./ScrollToTop";
import SessionExpiredWrapper from "./SessionExpiredWrapper";
import { pointsExchangeRoutes } from "./routes/pointsExchange.routes";

const router = createBrowserRouter([
  {
    element: <ScrollToTop />,
    children: [
      {
        element: <AppInitializer />,
        children: [
          {
            element: <SessionExpiredWrapper />,
            children: [
              {
                element: <RouteWrapper />,
                children: [
                  authRoutes,
                  flightsRoutes,
                  giftcardRoutes,
                  hotelRoutes,
                  pointsExchangeRoutes,
                  discountsRoutes,
                  topupRoutes,
                  userRoutes,
                  {
                    path: "*",
                    element: <NotFound />
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
]);

export default function AppRouter() {
  return <RouterProvider router={router} fallbackElement={<SplashScreen isLoading />} />;
}
